module.exports = __webpack_public_path__ + "img/potencia_r_c.a13b403c.svg";